export default __webpack_public_path__ + "static/media/A5Unselect.7aaac3d2.svg";